import {Component, input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'homey-page-title',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss'
})
export class PageTitleComponent {
  public readonly title = input.required<string>();
  public readonly center = input<boolean>(false);
  public readonly marginStyle = input<'small' | 'regular' | 'none'>('regular');
  public readonly atPageTop = input<boolean>(true);
}
